import { CenterScreenModal } from '../atoms'
import { useOpeningElementsControllerContext, useUserLanguage } from '@/customHooks'
import { CreateSupplierForm } from '../organism';
import { Col, Row } from 'react-grid-system';
import { FetchResult } from '@apollo/client';
import { CreateSupplierMutation, UpdateSupplierMutation } from '@/graphql/generated';

const textsData = {
  en: {
    title: 'Create a Supplier',
    confirmation: {
      create: {
        title: 'Supplier has been created',
        description: (firstName: string, lastName: string) => `User ${firstName} ${lastName} has been created succesfully`,
      },
      update: {
        title: 'Supplier has been updated',
        description: (firstName: string, lastName: string) => `User ${firstName} ${lastName} has been updated succesfully`,
      }
    }
  },
  es: {
    title: 'Crear a un Proveedor',
    confirmation: {
      create: {
        title: 'Proveedor creado con éxito',
        description: (firstName: string, lastName: string) => `${firstName} ${lastName} fue creado con éxito`,
      },
      update: {
        title: 'Proveedor actualizado con exito',
        description: (firstName: string, lastName: string) => `${firstName} ${lastName} fue actualizado con éxito`,
      }
    }
  }
}

export const CreateSupplierFormModal = () => {
  const { state, createSupplierFormModalClose, confirmDialogModalOpen} = useOpeningElementsControllerContext();

  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const onCreateSuccess = (response: FetchResult<CreateSupplierMutation> | FetchResult<UpdateSupplierMutation>) => {
      if (response.data && 'createSupplier' in response.data) {
        const user = response.data?.createSupplier
        if (user.__typename === 'SupplierOutput') {
          createSupplierFormModalClose()
          confirmDialogModalOpen({
            title: texts.confirmation.create.title,
            description: texts.confirmation.create.description(user.firstName, user.lastName),
          })
        }
      }
      else if (response.data && 'updateSupplier' in response.data) {
        const user = response.data?.updateSupplier
        createSupplierFormModalClose()
        confirmDialogModalOpen({
          title: texts.confirmation.update.title,
          description: texts.confirmation.update.description(user.firstName, user.lastName)
        })
      } 
    }

  return (
    <CenterScreenModal
      isOpen={state.isCreateSupplierFormModalOpen}
      onClose={createSupplierFormModalClose}
    >
      <Row>
        <Col>
          <h2>{texts.title}</h2>
        </Col>
      </Row>
      <CreateSupplierForm
        supplierDetail={null}
        activity="creating"
        onSuccess={onCreateSuccess}
      />   
    </CenterScreenModal>
  )
}
